export default {
  activateText: 'Uppdatera omedelbart efter utslÃ¤pp',
  deactivateText: 'Dra ner fÃ¶r att uppdatera',
  finishText: 'Avsluta uppdateringen'
};
